import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { appInfo, appInstance, department} from 'src/api';
import { history } from 'kts-platform-frame/routes';
import MyStore from 'kts-platform-frame/redux/MyStore';
import { reducers } from 'kts-platform-frame/redux';
import { message, Modal } from 'antd';
// import Authority from './UI.Authority';

class ModulesAction extends ActionBasic<ModulesState> {
    /**
     * 初始化数据
     */
    public initData = (appKey: string) => {
        this.modulesState.appKey = appKey;
        this.setModulesState(this.modulesState);
        this.updata();
    }
    /** 获取数据 */
    public updata = async () => {
        const param = {
            appKey: this.modulesState.appKey,
        };
        const appData = await appInfo.appInfoGet(this, param);
        if (!appData.er) {
            this.modulesState.appInfo = appData.res;
            this.setModulesState(this.modulesState);
        } else {
            history.push(`/workbench/platform/appStore/appManagement`);
        }
    }
    
    /** 获取应用实例权限: 用户 */
    public permissionQuery = async () => {
        const param = {
            appId: this.modulesState.appInfo.appId,
            permissionType: 0,

        };
        /** 权限类型 permissionType 0-表示用户，1-表示部门 */
        const appData = await appInstance.permissionQuery(this, param);
        if (!appData.er) {
            this.modulesState.permissionUserObjects = appData.res.permissionUserObjects || [];
            this.setModulesState(this.modulesState);
        }
        // 查询公司 人员列表
        this.modulesState.companyUserParam.pageNum = 1;
        this.modulesState.companyUserParam.pageSize = 10;
        this.modulesState.companyUserList = [];
        this.setModulesState(this.modulesState);
        this.companyUserQuery();
    }
    public onChangeTab = (pathkey) => {  
        this.modulesState.tabchange = pathkey; 
        this.setModulesState(this.modulesState);   
    }
     /** 获取应用权限: 部门 */
     public permissionDepQuery = async () => {
        const param = {
            appId: this.modulesState.appInfo.appId,
            permissionType: 1,

        };
        /** 权限类型 permissionType 0-表示用户，1-表示部门 */ 
        const appData = await appInstance.permissionQuery(null, param); 
        if (!appData.er) {  
            this.modulesState.permissionDepObjects = appData.res.permissionDepObjects || [];
            // values.deptpermision 格式: [{label:"12",value:"f80f9050-b1c6-44c3-bab8-b74a0a5b8d49"}]
            this.modulesState.permissionDepObjectsValues = appData.res.permissionDepObjects.map((item, index) => {
                return {
                    value: item.objectId
                };
            });
            this.setModulesState(this.modulesState);
        }  
        this.setModulesState(this.modulesState); 
    } 
    public departmentQuery = async () => {
        const res = await department.depList(this);
        if(!res.er) { 
            this.modulesState.departmentQuery = res.res.map((item, index) => {
                return {
                    ...item,
                    value: item.departmentId,
                    key: index,
                    label: item.name,
                };
            });
            this.modulesState.departtreeDate = this.buildTree(this.modulesState.departmentQuery); 
            this.setModulesState();
        }
    }
    /** 查询公司 人员列表 */
    public companyUserQuery = async () => {
        const param = {
            nickName: this.modulesState.onSearch,
            email: undefined,
            pageNum: this.modulesState.companyUserParam.pageNum,
            pageSize: this.modulesState.companyUserParam.pageSize,
        };
        const companyUserQuery = await appInstance.companyUserQuery(this, param);
        if (!companyUserQuery.er) {
            this.modulesState.companyUserList = this.modulesState.companyUserList.concat(companyUserQuery.res.items);
            this.modulesState.pageMeta = companyUserQuery.res.pageMeta;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 模糊查询人员列表
     */
    public onSearch(value?: string) {
        this.modulesState.companyUserParam.pageNum = 1;
        this.modulesState.companyUserParam.pageSize = 10;
        this.modulesState.companyUserList = [];
        this.modulesState.onSearch = value;
        this.setModulesState(this.modulesState);
        this.companyUserQuery();
    }
    /**
     * 加载更多 人员列表
     */
    public loadingMore() {
        this.modulesState.companyUserParam.pageNum = this.modulesState.companyUserParam.pageNum + 1;
        this.setModulesState(this.modulesState);
        this.companyUserQuery();
    }
    
    /**
     * 禁用app
     */
    public prohibit = async (appId: number) => {
        const param = {
            appId: appId,
        };
        const appData = await appInstance.appInstanceDisable(this, param);
        if (!appData.er) {
            message.success('禁用成功!');
            this.updata();
        }
    }

    /**
     * 是否激活
     */
    public isActivate = async (appId: number) => {
        const param = {
            appId: appId
        };
        const data = await appInfo.getPermissions(this, param);
        if (data.er) {
            return;
        }
        // 判断是否有 协议
        if (!data.res.appAgreementContent) {
            Modal.confirm({
                title: '激活提示',
                content: (
                    <p>接受许可激活!<br />
                        {
                            data.res.appCategories.map(item => {
                                return (<div key={item.apiCategoryId}>-该应用会访问{item.apiCategoryName}</div>);
                            })
                        }
                    </p>
                ),
                onOk: () => {
                    this.appInstanceActivate(appId);
                },
            });
        } else {
            this.activeTipsM(true);
            this.modulesState.appCategories = data.res.appCategories;
            this.modulesState.appAgreementContent = data.res.appAgreementContent;
            this.setModulesState();
        }
        
    }
    /**
     * 激活应用
     */
    public appInstanceActivate = async (appId: number) => {

        const param = {
            appId: appId
        };

        const appData = await appInstance.appInstanceActivate(this, param);
        if (!appData.er) {
            message.success('激活成功!');
            this.activeTipsM(false);
            this.updata();
        }
    }
    /**
     * 移除权限
     */
    public remove = (id: string) => { 
        this.modulesState.permissionUserObjects = this.modulesState.permissionUserObjects.filter(item => {
            return item.objectId !== id;
        });
        // this.setModulesState(this.modulesState);
        this.submitAuthority(); // 界面上屏蔽确认按钮
    }
    /**
     * 添加权限
     */
    public add = (id: string) => {
        this.modulesState.companyUserList.forEach(item => {
            if (item.userId === id) {
                let temp = {
                    objectId: item.userId,
                    objectName: item.nickName,
                    objectType: 0
                };
                this.modulesState.permissionUserObjects.push(temp);
                // this.setModulesState(this.modulesState);
            } 
        });
        this.submitAuthority(); // 界面上屏蔽确认按钮
    }
    /**
     * 添加权限 侧边栏关闭
     */
    public closeShowPanel = () => {
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide,{});
    }
    /** 保存权限设置 */
    public submitAuthority = async () => {
        const param = {
            appId: this.modulesState.appInfo.appId,
            permissionBizObjects: this.modulesState.permissionUserObjects, 
            permissionType: 0, // 权限类型 0-表示用户，1-表示部门
        };

        const appData = await appInstance.permissionOverride(this, param);
        if (!appData.er) {
            message.success('保存成功!');
        }
        
    }
    /** 改变部门权限 */
    public changeDeptPermision = async (params) => {  
        const deptsObject = {};
        const param = {
            appId: this.modulesState.appInfo.appId,
            permissionBizObjects: params, 
            permissionType: 1, // 权限类型 0-表示用户，1-表示部门
        };

        const appData = await appInstance.permissionOverride(this, param);
        if (!appData.er) {
            message.success('部门权限保存成功!');
        }
    }
    /** 刷新秘钥 */
    public reFresh = async () => {
        const res = await appInfo.autoRefresh(this, {appKey: this.modulesState.appKey});
        if (!res.er) {
            this.initData(this.modulesState.appKey);
        }
    }

    public updateDisabledModal = (b) => {
        this.modulesState.disabledModal = b;
        this.setModulesState();
    }

    private buildTree=(data)=>{
        let dataChildList=data.filter((item)=>item.parentDepartmentId);
        let dataRootList=[];
        for(let i=0; i<data.length; i++){
            data[i].children=[];
            if(!data[i].parentDepartmentId){
                dataRootList.push(data[i]);
            }
        }
        let tree = this.loopChildData(dataRootList, dataChildList);
        return tree;
    }

    private loopChildData=(parent, children, insert=false) => {
        for(let i=0; i<parent.length; i++){
            for(let x=0; x<children.length; x++){
                if(parent[i].departmentId === children[x].parentDepartmentId){
                    parent[i].children.push(children[x]);
                }
            }
            if(parent[i].children.length > 0){
                this.loopChildData(parent[i].children, children, true);
            }
        }
        if(insert) {
            return;
        }else{
            return parent;
        }
    }
    /** 激活弹框提示 */
    public activeTipsM = (isOpen: boolean) => {
        this.modulesState.activTipsM = isOpen;
        this.modulesState.isReadCheckd = false;
        this.setModulesState();
    }
    /** 监听 激活提示框 check按钮 */
    public onChangeCheck = (e) => {
        this.modulesState.isReadCheckd = e.target.checked;
        this.setModulesState();
    }

}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppDetail/Modules.Action.tsx